const STYLES = {
  queued: "text-amber-400 bg-amber-400/10 border-amber-700",
  processing: "text-sky-400 bg-sky-400/10 border-sky-700",
  completed: "text-emerald-400 bg-emerald-400/10 border-emerald-700",
  failed: "text-rose-400 bg-rose-400/10 border-rose-700",
  cancelled: "text-slate-400 bg-slate-400/10 border-slate-600",
  pass: "text-emerald-400 bg-emerald-400/10 border-emerald-700",
  fail: "text-rose-400 bg-rose-400/10 border-rose-700",
  pending: "text-slate-400 bg-slate-400/10 border-slate-600",
  ready: "text-emerald-400 bg-emerald-400/10 border-emerald-700",
};

export const StatusBadge = ({ status, progress, testId }) => (
  <span data-testid={testId || `status-badge-${status}`}
    className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm border text-[11px] font-mono uppercase tracking-wider ${STYLES[status] || STYLES.pending}`}>
    {status === "processing" && <span className="h-1.5 w-1.5 rounded-full bg-sky-400 pulse-dot" />}
    {status}{status === "processing" && progress != null ? ` ${progress}%` : ""}
  </span>
);
